/**
 * CES TerminalId for Fan Builder CustomerService calls from web POS
 * (coupon validate/use, loyalty panel).
 */
export const FAN_BUILDER_WEB_POS_TERMINAL_ID = "1"

/**
 * When Fan Builder coupon “Scan” is armed, this attribute is set on a wrapper so
 * `useBarcodeScanner` can skip pipe-delimited capture (otherwise scans hit product lookup).
 */
export const FAN_BUILDER_COUPON_ARMED_SELECTOR =
  "[data-fan-builder-coupon-armed]"

/** Spread onto the armed wrapper when `listeningForFanBuilderScan` is true. */
export const fanBuilderCouponArmedDomProps = {
  "data-fan-builder-coupon-armed": true,
} as const
